import {FC} from 'react'
import {useIntl} from 'react-intl'
import {useDispatch} from 'react-redux'
import {filterSchedulerDataChange, selectSchedulerLogsFilter} from '../redux/SchedulerRedux'
import {useAppSelector} from '../../../../setup/redux/hooks'
import {SchedulerLogStatus} from '../constants'
import {SettingReferenceModel} from '../../setting-reference/models/SettingReferenceModel'
type Props = {
  settings: SettingReferenceModel[]
}

const SchedulerExecuteLogsFilter: FC<Props> = ({settings}) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const filter = useAppSelector(selectSchedulerLogsFilter)

  return (
    <div className='card-title'>
      <div className='d-flex align-items-center position-relative my-1'>
        <input
          type='text'
          className='form-control form-control-solid w-250px me-3'
          placeholder={intl.formatMessage({id: 'SCHEDULER.LOGS.FILTER.NAME'})}
          value={filter.name}
          onChange={(e) =>
            dispatch(
              filterSchedulerDataChange({
                ...filter,
                name: e.target.value ?? undefined,
              })
            )
          }
        />
        <select
          className='form-select form-select-solid w-150px me-3'
          value={filter.settingId ?? ''}
          onChange={(e) =>
            dispatch(
              filterSchedulerDataChange({
                ...filter,
                settingId: e.target.value ? parseInt(e.target.value) : undefined,
              })
            )
          }
        >
          <option value=''>
            {intl.formatMessage({id: 'SCHEDULER.LOGS.FILTER.ALL_STATUS'})}
          </option>
          {settings.map((item: SettingReferenceModel) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
        <select
          className='form-select form-select-solid w-150px me-3'
          value={filter.status ?? ''}
          onChange={(e) =>
            dispatch(
              filterSchedulerDataChange({
                ...filter,
                status: e.target.value
                  ? (e.target.value as SchedulerLogStatus)
                  : undefined,
              })
            )
          }
        >
          <option value=''>
            {intl.formatMessage({id: 'SCHEDULER.LOGS.FILTER.ALL_STATUS'})}
          </option>
          {Object.values(SchedulerLogStatus).map((item: any) => (
            <option key={item} value={item}>
              {intl.formatMessage({id: 'Scheduler.STATUS.' + item})}
            </option>
          ))}
        </select>
        {/* <input
          type='date'
          className='form-control form-control-solid w-150px me-3'
          value={filter.fromDate}
          onChange={(e) => filterSchedulerDataChange({...filter, fromDate: e.target.value})}
        />
        <input
          type='date'
          className='form-control form-control-solid w-150px me-3'
          value={filter.toDate}
          onChange={(e) => filterSchedulerDataChange({...filter, toDate: e.target.value})}
        />

        <button className='btn btn-secondary' onClick={handleReset}>
          {intl.formatMessage({id: 'SYSTEM.RESET'})}
        </button> */}
      </div>
    </div>
  )
}

export default SchedulerExecuteLogsFilter
